import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const BenefitsModalTableWrapper = styled.div``;

interface IBenefitsModalTableLineProps {
  isOpaque?: boolean;
}

export const BenefitsModalTableLine = styled.div<IBenefitsModalTableLineProps>`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0 0.5rem 0.5rem;
  border-bottom: 1px solid ${theme.palette.neutralLight};
  opacity: ${({ isOpaque }) => (isOpaque ? '0.5' : '1')};
`;

export const BrandName = styled.span`
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 75%;
`;
